"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
function withReadOnlyComponent(OriginComponent, readOnlyClassName) {
  var WrapperComponent = function WrapperComponent(_a) {
    var readOnly = _a.readOnly,
      className = _a.className,
      disabled = _a.disabled,
      forwardedRef = _a.forwardedRef,
      restProps = __rest(_a, ["readOnly", "className", "disabled", "forwardedRef"]);
    return /*#__PURE__*/_react["default"].createElement(OriginComponent, (0, _extends2["default"])({
      ref: forwardedRef,
      disabled: disabled !== undefined ? disabled : readOnly,
      className: (0, _classnames["default"])(className, (0, _defineProperty2["default"])({}, readOnlyClassName, readOnly && !disabled))
    }, restProps));
  };
  var ForwardRefComponent = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(WrapperComponent, (0, _extends2["default"])({
      forwardedRef: ref
    }, props));
  });
  ForwardRefComponent.displayName = "withReadOnly".concat(OriginComponent.displayName || OriginComponent.name);
  return ForwardRefComponent;
}
var _default = exports["default"] = withReadOnlyComponent;